import React from 'react'
import { Link } from 'react-router-dom'
import bg1 from '../../assets/images/background/bg-1.png'
import bg2 from '../../assets/images/background/bg-2.png'
import offerimg1 from '../../assets/images/resource/offer-image-1.jpg'
import offerimg2 from '../../assets/images/resource/offer-image-2.jpg'
import offerimg3 from '../../assets/images/resource/offer-image-3.jpg'



function Offer() {
    return (
        <>
            <section className="we-offer-section">

                <div className="left-bot-bg"><img src={bg1} alt="" title="" /></div>

                <div className="right-top-bg"><img src={bg2} alt="" title="" /></div>

                <div className="auto-container">

                    <div className="title-box centered">

                        <div className="subtitle" style={{lineHeight:'1.5'}}><span>Connoisseurs of Quality and Freshness</span></div>

                        <div className="pattern-image">

                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Indulge in Flavours of Indo-Canadian Fusion</h2>
                        <div className="text">Discover a culinary journey of premium quality and freshness, where every dish is crafted to perfection to satisfy your discerning palate.</div>

                    </div>

                    <div className="row justify-content-center clearfix">

                        <div className="offer-block col-xl-4 col-lg-4 col-md-6 col-sm-12">

                            <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="image"><Link to="/menu"><img src={offerimg1} alt="" /></Link></div>
                                <h3><Link to="/menu">From the Tandoor</Link></h3>
                                <div className="more-link"><Link to="/menu">view menu</Link></div>
                            </div>

                        </div>


                        <div className="offer-block col-xl-4 col-lg-4 col-md-6 col-sm-12">

                            <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="300ms">
                                <div className="image"><Link to="/menu"><img src={offerimg2} alt="" /></Link></div>
                                <h3><Link to="/menu">Combos<br/><span style={{fontSize:'75%'}}>Dinner for Two</span></Link></h3>
                                <div className="more-link"><Link to="/menu">view menu</Link></div>
                            </div>

                        </div>


                        <div className="offer-block col-xl-4 col-lg-4 col-md-6 col-sm-12">

                            <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="600ms">
                                <div className="image"><Link to="/menu"><img src={offerimg3} alt="" /></Link></div>
                                <h3><Link to="/menu">Biryani</Link></h3>
                                <div className="more-link"><Link to="/menu">view menu</Link></div>
                            </div>

                        </div>

                    </div>

                </div>

            </section>
        </>
    )
}

export default Offer